export default __webpack_public_path__ + "static/media/loading_short.74f57b40.gif";